import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import { useForm, Controller } from 'react-hook-form';

import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import NavBar from '../NavBar/navbar';
import axios from 'axios';
import { useRoutes, navigate } from 'hookrouter';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(18),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function SignIn() {
  const classes = useStyles();

  if ('auth' in localStorage && localStorage.getItem('auth') === 'true') {
    navigate('/home/', true);
    console.log('Yes');
  }

  const { register, control, handleSubmit } = useForm();
  const Swal = require('sweetalert2');

  const onSubmit = (data) => {
    let cred = {
      username: data.username,
      password: data.password,
    };
    axios
      .post('/api/auth/login/', cred, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        var jsonResponse = response.data;
        if (jsonResponse.status === true) {
          localStorage.setItem('auth', 'true');
          localStorage.setItem('username', data.username.toLowerCase());
          navigate('/home/', true);
        } else if (jsonResponse.status === false) {
          Swal.fire({
            icon: 'error',
            title: 'Link Search Authentication',
            text: 'Invalid credentials',
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Link Search Authentication',
          text: 'Connection Failed',
        });
      });
  };

  return (
    <>
      <NavBar />
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <form className={classes.form} noValidate onSubmit={handleSubmit(onSubmit)}>
            <Controller
              as={TextField}
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="username"
              label="Username"
              inputRef={register}
              control={control}
              name="username"
              autoComplete="username"
              autoFocus
            />
            <Controller
              as={TextField}
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              inputRef={register}
              control={control}
              id="password"
              autoComplete="current-password"
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              Sign In
            </Button>
            <Grid container>
              <Grid item xs></Grid>
              <Grid item></Grid>
            </Grid>
          </form>
        </div>
      </Container>
    </>
  );
}
